import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

// LENDMARQ DIVERGENCE: tpo wraps its whole app in a LocalizationProvider
// (src/index.js, AdapterDayjs). This app has no app-level provider — its own
// date inputs each carry one (components/inputs/DateInput.jsx, with
// AdapterDateFns) — so the picker is wrapped here instead. Dayjs, not date-fns,
// because every value in this vendored tree is a dayjs object.
const DateInput = ({ value, onChange, onBlur, disabled, fullWidth, error, helperText }) => {
  const dValue = value ? dayjs(value) : null;
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      value={dValue}
      onChange={(next) => onChange(next ? next.toISOString() : "")}
      disabled={disabled}
      slotProps={{
        textField: {
          fullWidth,
          onBlur,
          error,
          helperText,
          size: "small",
        },
      }}
    />
    </LocalizationProvider>
  );
};

export default DateInput;
